/**
 * RENDER BOLD
 * Display a message with its **bold** parts (used by the checks of a project)
 * Wrapped in one span : in a flex container the spaces next to a bold part would be dropped
 */

export default function renderBold(message: string) {
  return <span>{message.split(/\*\*(.+?)\*\*/g).map((part, i) => (i % 2 === 1 ? <b key={i}>{part}</b> : part))}</span>
}
